(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("rc-dialog"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "rc-dialog"], factory);
	else if(typeof exports === 'object')
		exports["@aidesign/aid-base"] = factory(require("react"), require("rc-dialog"));
	else
		root["@aidesign/aid-base"] = factory(root["react"], root["rc-dialog"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__10__) {
return 